export default {"src":"/_next/static/media/iconSHIB.bce3bdc0.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};